<template>
  <div class="bankcard-component">
    <div class="bankcard-title">已绑定银行卡({{cardList.length}}/5)</div>
    <div v-if="cardList.length==0" class="empty-panel">
      <Empty text="暂无绑定的银行卡,最多支持绑定5张" :imgWidth="250" :img="require('@/assets/img/empty/card.png')">
        <template v-slot:content>
          <div class="empty-add" @click="addCard">添加银行卡</div>
        </template>
      </Empty>

    </div>
    <div v-else>
      <el-row :gutter="20">
        <el-col :span="8" v-for="(item,index) in cardList" :key="index">
          <div class="card">
            <div class="card-content">
              <div class="content-img"><img src="../../assets/img/child/bank-card.png" /></div>
              <div class="content-text">
                <div class="card-name">{{item.bank}}</div>
                <div class="card-number">**** **** ****  {{item.small_card}}</div>
              </div>
            </div>
            <div class="delete" @click="handleRemove(item.id)"><img src="../../assets/img/child/bank-delete.png" /></div>
          </div>
        </el-col>

        <el-col :span="8" v-if="cardList.length<5">
          <div class="card add"  @click="addCard">
            + 添加银行卡
          </div>
        </el-col>

      </el-row>
    </div>

    <AddCardDialog @refresh="getListInfo" ref="AddCardDialog"></AddCardDialog>
    <DeleteCardDialog  @refresh="getListInfo" ref="DeleteCardDialog"></DeleteCardDialog>
  </div>

</template>

<script>
import AddCardDialog from "@/components/dialog/AddCardDialog"
import DeleteCardDialog from "@/components/dialog/DeleteCardDialog"
import { get,post } from "../../util/http";
import Empty from "@/components/empty/empty"
export default {
  components:{
    AddCardDialog,
    DeleteCardDialog,
    Empty
  },
	data(){
		return{
      cardList:[]
		}
	},
  created(){
    this.getListInfo()
  },
	methods: {
    getListInfo(){
      let data ={};
      post({
        url: "/api/user/getBanks",
        data
      }).then(({ data: { data } })  => {
        data.forEach(v=>{
          v.small_card = v.card.substr(-4);
        })
        this.cardList = data;
        // this.$emit('backCount', data.count)
      })
      .catch(err=>{
        console.log(err);
      })
    },
    addCard(){
      if(this.cardList.length>4){ return; }
      this.$refs.AddCardDialog.open();
    },
    handleRemove(id=0){
      this.$refs.DeleteCardDialog.open(id);
    }
  },
}
</script>
<style  scoped lang="stylus">
.bankcard-component{
  .bankcard-title{
    font-size: 16px;
    color: #333333;
    font-weight: 600;
    padding : 15px 5px;
  }
  .empty-add{
    color: #ffffff;
    width : 250px;
    padding :10px 0px;
    text-align : center;
    background-image: linear-gradient(135deg, #4fe2af 0%, #13b67e 100%);
    border-radius : 20px;
    margin : 10px 0px;
    cursor : pointer;
  }
  .el-col{
    padding : 4px;
  }
  .card {
      position : relative;
      height: 88px;
      background-image: linear-gradient(135deg, #EEEEEE 0%, #FF7A6D 0%, #FF5766 100%);
      border-radius: 8px;
      box-sizing : content-box;
      .card-content{
        height : 100%;
        display : flex;
        color : #ffffff;
        justify-content : flex-start;
        align-items : center;
        padding : 0px 20px;
        .content-img{
          width : 40px;
          height : 40px;
          border-radius : 50%;
          background-color : #ffffff;
          display : flex;
          justify-content : center;
          align-items : center;
          margin-right : 15px;
          img{
            width : 26px;
            height : 26px;
          }
        }

        .content-text{
          height : 40px;
          padding : 0px 10px;
          .card-name{
            font-size: 14px;
            color: #FFFFFF;
            font-weight: 600;
            line-height : 20px;
          }
          .card-number{
            font-size: 18px;
            color: #FFFFFF;
            font-weight: 400;
          }
        }

      }
      &.add{
        border : 1px dashed #666666;
        font-size: 14px;
        color: #666666;
        font-weight: 400;
        display : flex;
        justify-content : center;
        align-items : center;
        background: #F7F7F7;
        cursor : pointer;
      }
      .delete{
        position : absolute;
        width : 24px;
        height : 24px;
        right : 10px;
        top : 10px;
        cursor : pointer;
        img{
          width : 100%;
          height : 100%;
        }
      }
  }
}
</style>
